/* @flow */
import React from 'react';
// $FlowIgnore
import { MdAssessment } from 'react-icons/md';

export default function ReportIcon({
  style
}: Object): React.Element {
  return <MdAssessment style={style} />;
}
